/*
 *
 *  sagas
 *
 */

import { call, take, put, race, select, all, delay } from "redux-saga/effects"

import {
  LOAD_RECORDS_META_DATA,
  LOAD_EMPLOYEE,
  LOAD_NIGHTSHIFT_DETAIL,
  LOAD_UPDATE_NIGHTSHIFT,
  UPDATE_LPND,
  DELETE_RECORD,
  APPLY_NIGHT_SHIFT_DETAILS
} from "./constants"

import {
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,
  loadEmployee,
  loadEmployeeSuccess,
  loadEmployeeError,
  loadNightShiftDetail,
  loadNightShiftDetailSuccess,
  loadNightShiftDetailError,
  loadUpdateNightShiftSuccess,
  loadUpdateNightShiftError,
  loadUpdateNightShift,
  updateLpndStatusSuccess,
  updateLpndStatusError,
 // deleteRecord,
  deleteRecordSuccess,
  deleteRecordError,
  applyNightShiftListSuccess,
  applyNightShiftListError
} from "./actions"

import {
  loadRecordsMetaData,
  loadEmployeeList,
  loadNightShiftList,
  updateNightShiftList,
  updateLpndList,
  deleteNightshift,
  applyNightShiftDetailsList
} from "./remotes"

//import {
//    selectRecords,
//   selectUpdateTimestamp
//} from './selectors'
import { selectSession } from "../session/selectors"
import { roleIds } from "../../helpers/tools"

function* loadRecordsMetaDataSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    yield race({
      metaData: take(LOAD_RECORDS_META_DATA),
    })

    try {
      let sessionDetails
      while (true) {
        // eslint-disable-line no-constant-condition
        const sessionInStore = yield select(selectSession())

        const { user = {} } = sessionInStore
        if (user && Object.keys(user).length > 0) {
          sessionDetails = sessionInStore
          break
        }
        yield delay(500)
      }

      let company
      let branch
      if (
        sessionDetails &&
        sessionDetails.user &&
        roleIds.includes(sessionDetails.user.roleId)
      ) {
        company = yield call(loadRecordsMetaData, "company", "post")
        branch = yield call(loadRecordsMetaData, "branch", "post")
      } else {
        company =
          (sessionDetails &&
            sessionDetails.user &&
            sessionDetails.user.company &&
            sessionDetails.user.company.length > 0 &&
            sessionDetails.user.company.map((_) => _.detail)) ||
          []
        branch =
          (sessionDetails &&
            sessionDetails.user &&
            sessionDetails.user.branch &&
            sessionDetails.user.branch.length > 0 &&
            sessionDetails.user.branch.map((_) => _.detail)) ||
          []
      }
      const department = yield call(loadRecordsMetaData, "department", "post")
      let recordsMetaData = {
        companyOptions:
          (company &&
            company.data &&
            company.data.length > 0 &&
            company.data.filter(_=> _.status === 1).map((c) =>
              Object.assign({}, { label: c.name, value: c._id })
            )) ||
          (company &&
            company.length > 0 &&
            company.map((c) =>
              Object.assign({}, { label: c.name, value: c._id })
            )) ||
          [],
        branchOptions:
          (branch &&
            branch.data &&
            branch.data.length > 0 &&
            branch.data.filter(_=> _.status === 1).map((c) =>
              Object.assign(
                {},
                { label: c.name, value: c._id, companyId: c.companyId }
              )
            )) ||
          (branch &&
            branch.length > 0 &&
            branch.map((c) =>
              Object.assign(
                {},
                { label: c.name, value: c._id, companyId: c.companyId }
              )
            )) ||
          [],
        departmentOptions:
          (department &&
            department.data &&
            department.data.length > 0 &&
            department.data.filter(_=> _.status === 1).map((c) =>
              Object.assign({}, { label: c.name, value: c._id })
            )) ||
          (department &&
            department.length > 0 &&
            department.map((c) =>
              Object.assign({}, { label: c.name, value: c._id })
            )) ||
          [],
      }

      yield put(loadRecordsMetaDataSuccess(recordsMetaData))
    } catch (error) {
      yield put(
        loadRecordsMetaDataError(
          (error && error.response && error.response.message) ||
            "Fetch Dropdown Records Failed"
        )
      )
    }
  }
}
// Employee filter Saga

function* loadEmployeeSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_EMPLOYEE),
    })

    const { explicitLoad } = load

    // const { id } = explicitLoad || {}
    yield put(loadEmployee(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadEmployeeList)

        if (result) {
          yield put(loadEmployeeSuccess(result.data))
        } else {
          yield put(loadEmployeeError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadEmployeeError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}
// nightshift
function* loadNightShiftSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_NIGHTSHIFT_DETAIL),
    })

    const { explicitLoad } = load

    const { applyFilter } = explicitLoad || {}
    yield put(loadNightShiftDetail(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadNightShiftList, applyFilter)

        if (result) {
          yield put(loadNightShiftDetailSuccess(result.Data))
        } else {
          yield put(loadNightShiftDetailSuccess([]))
          yield put(loadNightShiftDetailError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(loadNightShiftDetailSuccess([]))
        yield put(
          loadEmployeeError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

//update nightshift

function* updateNightShiftSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_UPDATE_NIGHTSHIFT),
    })

    const { explicitLoad } = load

    const { update_Nightshift } = explicitLoad || {}
    yield put(loadUpdateNightShift(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(updateNightShiftList, update_Nightshift)

        if (result) {
          yield put(loadUpdateNightShiftSuccess(result.Data))
        } else {
          yield put(loadUpdateNightShiftError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadUpdateNightShiftError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}
//update lpnd

function* updateLpndSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(UPDATE_LPND),
    })

    const { explicitLoad } = load

    const { update_Lpnd } = explicitLoad || {}
    yield put(explicitLoad) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(updateLpndList, update_Lpnd)

        if (result) {
          yield put(updateLpndStatusSuccess(result.Data))
        } else {
          yield put(updateLpndStatusError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          updateLpndStatusError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

//

//DELETE SAGA
function* deleteRecordSaga() {
 
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(DELETE_RECORD),
    })
    const {deleteData} = create || {}
    if (create) {
     // yield call(setSubmitting, true)
      try {
        yield call(deleteNightshift, deleteData)

        yield delay(1000)
        yield put(deleteRecordSuccess(deleteData))
        yield put((true))
       
      } catch (error) {
        yield put(
          deleteRecordError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } 
    }
  }
}

//Apply nightshift SAGA
function* applyNightShiftDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { edit } = yield race({
      edit: take(APPLY_NIGHT_SHIFT_DETAILS),
    })

    console.log("FFFF", edit)

    const { applyNightShiftDetails } = edit || {}

    if (edit) {
      try {
        yield call(applyNightShiftDetailsList, applyNightShiftDetails)
        // yield delay(1000)
        yield put(
          applyNightShiftListSuccess(
            applyNightShiftDetails,
            "Record Updated Successfully"
          )
        )
      } catch (error) {
        yield put(
          applyNightShiftListError(
            (error && error.response && error.response.message) ||
              "Update Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

export default function* recordsSaga() {
  yield all([
    loadRecordsMetaDataSaga(),
    loadEmployeeSaga(),
    loadNightShiftSaga(),
    updateNightShiftSaga(),
    updateLpndSaga(),
    deleteRecordSaga(),
    applyNightShiftDetailsSaga()
  ])
}
